import React from 'react';
import { 
  User, Heart, Users, Baby, ClipboardList, 
  Brain, Stethoscope, UsersRound 
} from 'lucide-react';

const Services = () => {
  return (
    <div className="services-page" data-testid="services-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1 className="heading-hero">Nuestros Servicios</h1>
          <p className="hero-subtitle body-large">
            Atención psicológica integral para todas las edades y necesidades
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-detail-section">
        <div className="container">
          <div className="services-detail-grid">
            <div className="service-detail-card">
              <div className="service-icon-container">
                <User size={32} />
              </div>
              <h3 className="heading-2">Terapia Individual</h3>
              <p className="body-medium">Atención personalizada para adultos, adolescentes y niños. Tratamiento de ansiedad, depresión, estrés y otros trastornos emocionales.</p>
              <a href="https://wa.me/51934442759" target="_blank" rel="noopener noreferrer" className="btn-secondary">
                CONSULTAR
              </a>
            </div>

            <div className="service-detail-card">
              <div className="service-icon-container">
                <Heart size={32} />
              </div>
              <h3 className="heading-2">Terapia de Pareja</h3>
              <p className="body-medium">Fortalecimiento de vínculos, resolución de conflictos y mejora de la comunicación en las relaciones de pareja.</p>
              <a href="https://wa.me/51934442759" target="_blank" rel="noopener noreferrer" className="btn-secondary">
                CONSULTAR
              </a>
            </div>

            <div className="service-detail-card">
              <div className="service-icon-container">
                <Users size={32} />
              </div>
              <h3 className="heading-2">Terapia Familiar</h3>
              <p className="body-medium">Abordaje sistémico para resolver conflictos familiares y mejorar la dinámica del hogar.</p>
              <a href="https://wa.me/51934442759" target="_blank" rel="noopener noreferrer" className="btn-secondary">
                CONSULTAR
              </a>
            </div>

            <div className="service-detail-card">
              <div className="service-icon-container">
                <Baby size={32} />
              </div>
              <h3 className="heading-2">Psicología Infantil y Adolescente</h3>
              <p className="body-medium">Tratamiento especializado en trastornos del neurodesarrollo, problemas de conducta y aprendizaje.</p>
              <a href="https://wa.me/51934442759" target="_blank" rel="noopener noreferrer" className="btn-secondary">
                CONSULTAR
              </a>
            </div>

            <div className="service-detail-card">
              <div className="service-icon-container">
                <ClipboardList size={32} />
              </div>
              <h3 className="heading-2">Evaluaciones Psicológicas</h3>
              <p className="body-medium">Evaluaciones completas para diagnóstico de trastornos emocionales, cognitivos y de personalidad.</p>
              <a href="https://wa.me/51934442759" target="_blank" rel="noopener noreferrer" className="btn-secondary">
                CONSULTAR
              </a>
            </div>

            <div className="service-detail-card">
              <div className="service-icon-container">
                <Brain size={32} />
              </div>
              <h3 className="heading-2">Neuropsicología</h3>
              <p className="body-medium">Evaluación y tratamiento de trastornos cognitivos, TDAH, autismo, dislexia y otras condiciones neuropsicológicas.</p>
              <a href="https://wa.me/51934442759" target="_blank" rel="noopener noreferrer" className="btn-secondary">
                CONSULTAR
              </a>
            </div>

            <div className="service-detail-card">
              <div className="service-icon-container">
                <Stethoscope size={32} />
              </div>
              <h3 className="heading-2">Interconsultas Psiquiátricas</h3>
              <p className="body-medium">Atención médica especializada en salud mental con prescripción de tratamiento farmacológico cuando sea necesario.</p>
              <a href="https://wa.me/51934442759" target="_blank" rel="noopener noreferrer" className="btn-secondary">
                CONSULTAR
              </a>
            </div>

            <div className="service-detail-card">
              <div className="service-icon-container">
                <UsersRound size={32} />
              </div>
              <h3 className="heading-2">Talleres y Grupos de Apoyo</h3>
              <p className="body-medium">Espacios grupales para el desarrollo de habilidades emocionales y sociales.</p>
              <a href="https://wa.me/51934442759" target="_blank" rel="noopener noreferrer" className="btn-secondary">
                CONSULTAR
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Info Section */}
      <section className="info-section">
        <div className="container">
          <div className="info-grid">
            <div className="info-card">
              <h3 className="heading-2">Metodología</h3>
              <p className="body-medium">
                Trabajamos con enfoques basados en evidencia científica, incluyendo Terapia Cognitivo Conductual, 
                Terapia Racional Emotiva, enfoque Sistémico y Terapia Dialéctico Conductual.
              </p>
            </div>

            <div className="info-card">
              <h3 className="heading-2">Modalidades</h3>
              <p className="body-medium">
                Ofrecemos sesiones presenciales y online, adaptándonos a tus necesidades y preferencias. 
                Cada sesión dura entre 45 y 60 minutos.
              </p>
            </div>

            <div className="info-card">
              <h3 className="heading-2">Proceso</h3>
              <p className="body-medium">
                Iniciamos con una evaluación completa, seguida de un plan de tratamiento personalizado. 
                El seguimiento continuo garantiza resultados efectivos.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="heading-1">¿Listo para Comenzar?</h2>
            <p className="body-large">
              Agenda tu primera consulta y descubre cómo podemos ayudarte.
            </p>
            <a
              href="https://wa.me/51934442759"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary large"
            >
              AGENDAR CITA AHORA
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
